import RequestsSwiper from "./requests-swiper-mapping";

export default RequestsSwiper;
